import React, { createContext, useContext, useState, useCallback } from "react";
import axiosInstance from "../AxiosInstance";
import config from "../config/config";

const MetricsContext = createContext();

export const ApiMetricsProvider = ({ children }) => {
  const [metrics, setMetrics] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const resp = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/admin/api/metrics`
      );
      setMetrics(resp.data);
      console.log("Fetched metrics:", resp.data);
    } catch (err) {
      console.error("Failed to fetch metrics:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <MetricsContext.Provider
      value={{ metrics, loading, error, fetchMetrics }}
    >
      {children}
    </MetricsContext.Provider>
  );
};

export const useApiMetrics = () => useContext(MetricsContext);
